/**
 * Off-intent image-tool toolbar — a button row beside the result image that runs
 * the create-runtime tools (remove-bg / upscale / segment) on an already-present
 * image. NOT part of the intent flow. why → ADR-005 #3.
 */

import { removeBackground, upscaleImage, smartSegment } from '../../api/ai-tools.js'
import { showToast } from '../../utils/toast.js'
import { createLogger } from '../../utils/logger.js'
const log = createLogger('create-ui.image-tools')


const TOOLS = [
  { id: 'remove-bg', label: 'Remove BG', icon: 'ph-scissors', run: (url) => removeBackground(url) },
  { id: 'upscale', label: 'Upscale 4x', icon: 'ph-arrows-out-simple', run: (url) => upscaleImage(url, 4) },
  { id: 'segment', label: 'Segment', icon: 'ph-selection-inverse', run: (url) => smartSegment(url) },
]

/**
 * Render the tool buttons into `container`. `getUrl()` returns the current image
 * URL; `onResult(newUrl, toolRes)` is called with the tool output to swap the
 * image — the full tool response rides along so the caller can keep identity
 * fields (asset_id) attached to the swapped result. why → review F5.
 */
export function renderImageToolbar(container, getUrl, onResult) {
  if (!container) return
  container.innerHTML = TOOLS.map(
    (t) =>
      `<button type="button" class="img-tool-btn" data-tool="${t.id}" title="${t.label}" aria-label="${t.label}"><i class="ph ${t.icon}" aria-hidden="true"></i></button>`
  ).join('')

  container.querySelectorAll('.img-tool-btn').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const tool = TOOLS.find((t) => t.id === btn.dataset.tool)
      const url = getUrl?.()
      if (!tool || !url) return
      btn.disabled = true
      btn.classList.add('loading')
      try {
        const res = await tool.run(url)
        const newUrl = res?.image_url || res?.url
        if (newUrl) onResult?.(newUrl, res)
        else showToast(`${tool.label} returned no image`, 'error')
      } catch (err) {
        log.error(`[image-tools] ${tool.id} failed:`, err)
        showToast(`${tool.label} failed`, 'error')
      } finally {
        btn.disabled = false
        btn.classList.remove('loading')
      }
    })
  })
}
